module.exports = __webpack_public_path__ + "img/padlock.f344c5c8.svg";